export default "__VITE_ASSET__DdeYMWgx__"